<div
  class="flex items-center justify-center min-h-screen px-4 bg-base-100"
>
  <div class="flex flex-col w-full max-w-md gap-4">
    <h1 class="text-2xl font-bold text-midnight">
      Two-factor authentication required
    </h1>
    <p class="text-sm text-midnight/80">
      Your organization requires an authenticator app for sign-in. Set it up
      now to continue — this step can&apos;t be skipped.
    </p>

    @if (!pendingActivation) {
      <et-atoms-input class="mt-2">
        <label class="!bg-base-100">Confirm your password</label>
        <input
          #pw
          class="!bg-transparent !w-96"
          etAtomsInput
          type="password"
          autocomplete="current-password"
        />
      </et-atoms-input>
      <div class="flex gap-3">
        <button
          type="button"
          [disabled]="submitting"
          (click)="start(pw.value)"
          class="capitalize rounded-full w-44 btn btn-xl btn-primary"
        >
          Continue
        </button>
      </div>
    }

    @if (pendingActivation) {
      <p class="text-sm text-midnight/80">
        Scan this code with an authenticator app (Google Authenticator,
        1Password, Authy), then enter the 6-digit code it shows to finish
        setting up 2FA.
      </p>
      @if (qrDataUrl) {
        <img
          [src]="qrDataUrl"
          alt="Scan with your authenticator app"
          class="w-40 h-40"
        />
      }
      @if (totpURI) {
        <div class="text-xs break-all text-midnight">
          <p class="font-medium">Can&apos;t scan? Enter this manually:</p>
          <code>{{ totpURI }}</code>
        </div>
      }
      @if (totpEnabled) {
        <button
          type="button"
          (click)="
            activationMethod = activationMethod === 'totp' ? 'otp' : 'totp';
            error = false
          "
          class="self-start underline normal-case btn btn-link text-midnight"
        >
          {{
            activationMethod === 'totp'
              ? 'Use email/SMS code instead'
              : 'Use authenticator app instead'
          }}
        </button>
      }
      @if (activationMethod === 'otp') {
        <button
          type="button"
          (click)="sendActivationOtp()"
          class="self-start underline normal-case btn btn-link text-midnight"
        >
          Send me a code
        </button>
      }
      <et-atoms-input class="w-full">
        <label class="!bg-base-100">6-digit code</label>
        <input
          #code
          class="!bg-transparent !w-full"
          etAtomsInput
          type="text"
          inputmode="numeric"
          maxlength="6"
        />
      </et-atoms-input>
      <button
        type="button"
        [disabled]="submitting"
        (click)="confirmActivation(code.value)"
        class="capitalize rounded-full w-44 btn btn-xl btn-primary"
      >
        Verify &amp; activate
      </button>
    }

    @if (error) {
      <p class="text-sm text-red-600" role="alert">
        @if (activationIncomplete) {
          That code was accepted, but authenticator setup did not finish.
          Enter the current code and try again.
        } @else {
          Something went wrong — check your password/code and try again.
        }
      </p>
    }

    <!-- Backup codes: single-use recovery. Shown once on enable. -->
    @if (backupCodes.length) {
      <div class="p-3 mt-2 rounded bg-base-200">
        <p class="text-sm font-medium text-midnight">
          Save these backup codes somewhere safe — each works once:
        </p>
        <ul class="mt-2 font-mono text-sm">
          @for (code of backupCodes; track code) {
            <li>{{ code }}</li>
          }
        </ul>
      </div>
    }
  </div>
</div>
